import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
var Close = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ _jsx("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.25",
            d: "M1.167 22.833 22.833 1.167m0 21.666L1.167 1.167"
        })
    });
};
export default /*#__PURE__*/ memo(Close);
